<template>
  <div>
    <a-alert
      :message="
        configurationType == 'examine'
          ? '中期检查录入配置完成后，项目填写人提交后，可在项目详情中查看。'
          : '绩效评价录入配置完成后，项目填写人提交后，可在项目详情中查看。'
      "
      banner
    />
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
      <a-form-item label="节点名称">
        <a-input
          placeholder="请输入"
          :value="configurationType == 'examine' ? '中期检查录入' : '绩效评价录入'"
        ></a-input>
      </a-form-item>
      <a-form-item label="发布单位">
        <a-input
          placeholder="自动读取"
          disabled
        ></a-input>
      </a-form-item>
      <a-form-item label="项目发布人">
        <a-input
          placeholder="自动读取"
          disabled
        ></a-input>
      </a-form-item>
      <a-form-item label="开始提交时间">
        <a-date-picker style="width:100%" placeholder="选择时间" />
      </a-form-item>
      <a-form-item label="上传截止时间">
        <a-date-picker style="width:100%" placeholder="选择时间" />
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  props: {
    configurationType: {
      type: String,
      default: '',
    },
  },
}
</script>

<style>
</style>